import { useEffect, useMemo, useState } from 'react';
import { useBanqueQuestions } from './useBanqueQuestions';

/**
 * Les questions des attendus d'un AUTRE niveau que la classe, ouverts dans la
 * composition (2026-09-29). Elles ne sont pas dans la banque du niveau de la
 * classe : un exercice généré est rangé au niveau de son exerciseur, une
 * question au niveau de la classe où elle a été écrite.
 *   - Attendu en cours d'un autre niveau : `banque-questions/?attendu=<id>`,
 *     quelques questions, jamais toute la banque du niveau.
 *   - Attendu du niveau de la classe (ou sans niveau connu) : aucun appel.
 *   - Les questions des attendus déjà ouverts restent gardées le temps de la
 *     page : le panier retrouve ses questions par la liste, une question
 *     sélectionnée sur un attendu de 6e ne doit pas en sortir quand on passe
 *     à un autre attendu.
 */
export const useQuestionsAttendusAutresNiveaux = (attendu, niveauClasse, refresh) => {
    const id = attendu?.niveau && niveauClasse && attendu.niveau !== niveauClasse ? attendu.id : null;
    const { data } = useBanqueQuestions({ attendu: id }, refresh, id ? undefined : 'not-enabled');

    const [parAttendu, setParAttendu] = useState({});
    useEffect(() => {
        if (!id || !Array.isArray(data)) return;
        // Pendant le chargement d'un nouvel attendu, la réponse précédente est
        // encore là : on ne garde que les questions de l'attendu demandé.
        setParAttendu((prev) => ({ ...prev, [id]: data.filter((q) => q.attendu === id) }));
    }, [id, data]);

    return useMemo(() => Object.values(parAttendu).flat(), [parAttendu]);
};
